import React from "react";
import styles from "./UpcomingAppointments.module.scss";

const UpcomingAppointments = ({ appointments }) => {
  if (!appointments || appointments.length === 0) {
    return <p className={styles.empty}>Aucun rendez-vous à venir</p>;
  }

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("fr-FR", {
      weekday: "short",
      day: "numeric",
      month: "short",
    });
  };

  const formatTime = (timeStr) => {
    if (!timeStr) return "";
    return timeStr.substring(0, 5);
  };

  return (
    <ul className={styles.list}>
      {appointments.map((rdv) => (
        <li key={rdv.id} className={styles.item}>
          <div className={styles.date}>
            <span className={styles.day}>{formatDate(rdv.date)}</span>
            <span className={styles.time}>{formatTime(rdv.start_time)}</span>
          </div>
          <div className={styles.details}>
            <span className={styles.client}>
              {rdv.firstname} {rdv.lastname}
            </span>
            <span className={styles.service}>
              {rdv.prestations && rdv.prestations.length > 0
                ? rdv.prestations.map((p) => p.prestation).filter(Boolean).join(", ")
                : "Sans prestation"}
            </span>
          </div>

        </li>
      ))}
    </ul>
  );
};

export default UpcomingAppointments;
